import React, { useContext } from 'react'
import { FormLabel } from '@material-ui/core'

import Checkbox from 'components/AssetPanels/Voiceover/components/Checkbox'
import TestVolume from 'components/AssetPanels/Voiceover/components/TestVolume'
import VolumeLevel from 'components/AssetPanels/Voiceover/components/VolumeLevel'

import { TranslationContext } from 'contexts/TranslationContext'
import styles from './volume.module.scss'


type Props = {
  stream: MediaStream | null,
  disable: boolean,
  constraints: MediaTrackConstraints,
  onAutoGainChange: (x: boolean) => void,
}

function Volume({ stream, disable, constraints, onAutoGainChange }: Props) {
  const { t } = useContext(TranslationContext)

  return (
    <>
      <div className={styles.label}>Volume level</div>
      <div className={styles.volume}>
        <VolumeLevel stream={stream} disable={disable} autoGainControl={Boolean(constraints.autoGainControl)} />
        <TestVolume stream={stream} disable={disable} />
      </div>
      <div className={styles.checkbox}>
        <FormLabel htmlFor={t('VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING')}>
          <Checkbox
            checked={Boolean(constraints.autoGainControl)}
            onChange={onAutoGainChange}
            disabled={disable}
            aria-label={t('VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING')}
            id={t('VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING')}
            emitValue
          />
        </FormLabel>
        <div>{t('VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING')}</div>
      </div>
    </>
  )
}

export default Volume
